import React from "react";
import ContentUnivercity from "./ContentUnivercity";

function ShortlistedUniver(props) {
  return <ContentUnivercity />;
}

export default ShortlistedUniver;
